import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import SubmittalsSidebar from 'src/components/submittalsSidebar/submittals-sidebar';

import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';

export default function SubmittalsSideBarLayout({ children }) {
  const nav = useBoolean();
  const renderNavVertical = <SubmittalsSidebar openNav={nav.value} onCloseNav={nav.onFalse} />;
  const lgUp = useResponsive('up', 'lg');
  return (
    <>
      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {lgUp && renderNavVertical}
        <Box
          sx={{
            overflow: 'hidden',
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}

SubmittalsSideBarLayout.propTypes = {
  children: PropTypes.node,
};
